import type { FindAllASTFavoritesResponseType } from 'src/api/generated/touring/types';
import { mapASTFavoriteType } from './helpers';
import type { FindAllASTFavoritesType } from './types';

export const mapFindAllASTFavoritesResponseType = (
  api: FindAllASTFavoritesResponseType
): FindAllASTFavoritesType => api.data.map(mapASTFavoriteType);
